import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const SmallCross = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 10 10">
      <path d="M9.002,0.157l-4.002,4.001l-3.998,-3.998c-0.238,-0.219 -0.602,-0.212 -0.828,0.014l-0.043,0.049c-0.188,0.233 -0.174,0.576 0.043,0.793l3.984,3.984l-3.998,3.998c-0.219,0.238 -0.212,0.602 0.014,0.828c0.226,0.226 0.59,0.233 0.824,0.017l4.002,-4.002l3.998,3.999c0.238,0.219 0.602,0.212 0.828,-0.014l0.043,-0.049c0.188,-0.233 0.174,-0.576 -0.043,-0.793l-3.985,-3.984l3.999,-3.998c0.219,-0.238 0.212,-0.602 -0.014,-0.828c-0.226,-0.226 -0.59,-0.233 -0.824,-0.017Z" />
    </svg>
  );
};

SmallCross.defaultProps = {
  width: '100%',
  height: '100%',
};
export default SmallCross;
